export default __webpack_public_path__ + "static/2019-largest-music-festivals-where-to-go-and-how-to-book-sziget-dd367e0df59e31bb2a104cb946f26b7f.jpg";